import React from "react";

interface BoundaryBarMarkerProps {
  markerPercent?: number;
  showLeftArrows?: boolean;
  showRightArrows?: boolean;
}

export const BoundaryBarMarker: React.FC<BoundaryBarMarkerProps> = ({
  markerPercent = 0,
  showLeftArrows = false,
  showRightArrows = false,
}) => {
  // Einfache Logik: Der Kreis ist immer bei x=14 (Mitte der 28px breiten Variante)
  // Die SVG-Größe ist immer gleich für konsistente Positionierung
  const svgWidth = 28;
  const circleX = 14;

  return (
    <svg
      className="boundary-bar-marker"
      width={svgWidth}
      height="11"
      viewBox={`0 0 ${svgWidth} 11`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        left: `${(markerPercent / 4) * 100}%`,
      }}
    >
      {/* Linke Trendpfeile */}
      {showLeftArrows && (
        <>
          <path d="M3 8.5L0 5.5L3 2.5V8.5Z" fill="white" />
          <path d="M7 8.5L4 5.5L7 2.5V8.5Z" fill="white" />
        </>
      )}

      {/* Kreis (immer bei x=14) */}
      <circle cx={circleX} cy="5.5" r="4.5" fill="white" stroke="black" />

      {/* Rechte Trendpfeile */}
      {showRightArrows && (
        <>
          <path d="M21 8.5L24 5.5L21 2.5V8.5Z" fill="white" />
          <path d="M25 8.5L28 5.5L25 2.5V8.5Z" fill="white" />
        </>
      )}
    </svg>
  );
};
